import React, { useContext } from 'react';
import { Context } from 'components/Store';
import { FormikTextArea } from 'components/UiKit/FormikFields';

const ShortDescription = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <FormikTextArea
      id="shortDescription"
      name="shortDescription"
      label="Short Description"
      disabled={!isEnableInfoTabEdit}
      placeholder="Enter short description"
    />
  );
};

export default ShortDescription;
